import React, { useEffect, useRef, useState } from "react";
import "../styles/dashboard.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import DashboardHoldingSection from "../components/DashboardHoldingSection";
import { Link, useNavigate } from "react-router-dom";
import DashboardTopHeaderSection from "../components/DashboardTopHeaderSection";
import AccountDeactivated from "../components/AccountDeactivated";
import "../styles/dashboard.css";
import disclaimer_image from "../images/dashboard/disclaimer_image.svg";
import RetirementPlan from "../images/icons/RetirementPlan.svg";
import BuyHouse from "../images/icons/BuyHouse.svg";
import UpArrowRound from "../images/icons/UpArrowRound.svg";
import { GoalCard } from "../components/GoalCard";
import InvestButton from "../components/InvestButton";
import { useDispatch, useSelector } from "react-redux";
import { userOnboardingGetDetails } from "../actions/usersActions";
import { getLocalStorageUserData } from "../utils/userData";
import { getGoalsList } from "../actions/goalsActions";
import HoldingSectionSidebar from "../components/HoldingSectionSidebar";
import Loader from "../loader/Loader-ui";
import "../styles/FundDetailInvestmentBox.css"; // Import styles
import { dashboardError } from "../actions/holdingAction";

// Functional component for the Home page
const Dashboard = () => {
  const naviagte = useNavigate();
  const dispatch = useDispatch();
  const isMounted = useRef(false);
  const goals = useSelector((state) => state.goals?.goalList?.data?.goalData);
  const user = useSelector((state) => state.users);
  const GoalData = useSelector(
    (state) => state.holdings?.dashboardDatas?.data?.goals
  );
  const dashboardErrorMessage = useSelector(
    (state) => state.holdings?.errorMessage?.data
  );
  const [showSwiper, setShowSwiper] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [goalNormalCall, setGoalNormalCall] = useState();
  const userData = getLocalStorageUserData();

  useEffect(() => {
    const fetchData = async () => {
      const payload = {
        id: userData?.id,
        perpage: "",
        pagenum: "",
      };
      try {
        setIsLoading(true);
        await dispatch(getGoalsList(payload)).then((res) => {
          setGoalNormalCall(res?.data?.goalData);
        });
      } catch (error) {
        console.error("API call failed: ", error);
      } finally {
        setIsLoading(false);
      }
    };
    const fetchErrors = async () => {
      try {
        setIsLoading(true);
        await dispatch(dashboardError());
      } catch (error) {
        console.error("API call failed: ", error);
      } finally {
        setIsLoading(false);
      }
    };
    // if (isMounted.current) {
    fetchData();
    fetchErrors();
    // } else {
    // isMounted.current = true;
    // }
  }, [userData?.id, dispatch]);

  const handleImageClick = () => {
    setShowSwiper((prevState) => !prevState);
  };

  const handleNavigate = () => {
    naviagte("/goals/add", { state: { from: "dashboard" } });
  };

  // Refs for custom navigation
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const { userOnboardGetData, userOnboardStoreData, loading, error } =
    useSelector((state) => state.users);
  useEffect(() => {
    const fetchData = async () => {
      const payload = {
        id: userData?.id,
        completed_wizard_step: "1",
      };
      try {
        setIsLoading(true);
        await dispatch(userOnboardingGetDetails(payload));
      } catch (error) {
        console.error("API call failed: ", error);
      } finally {
        setIsLoading(false);
      }
    };
    // if (isMounted.current) {
    fetchData();
    // }
    // else {
    //   isMounted.current = true;
    // }
  }, [dispatch]);

  const swiperRef = useRef(null);

  useEffect(() => {
    if (swiperRef.current && prevRef.current && nextRef.current) {
      swiperRef.current.params.navigation.prevEl = prevRef.current;
      swiperRef.current.params.navigation.nextEl = nextRef.current;

      // Re-init navigation
      swiperRef.current.navigation.destroy();
      swiperRef.current.navigation.init();
      swiperRef.current.navigation.update();
    }
  }, [goalNormalCall]); // Run again if slides change

  useEffect(() => {
    if (userOnboardGetData) {
      if (
        userOnboardGetData?.wizard_step == 4 ||
        userOnboardGetData?.wizard_step == 5
      ) {
        setIsVisible(true);
      } else if (userOnboardGetData?.wizard_step == 0) {
        naviagte("/personal-details");
      } else if (userOnboardGetData?.wizard_step == 1) {
        naviagte("/bank-details");
      } else if (userOnboardGetData?.wizard_step == 2) {
        naviagte("/fatca-declartion");
      } else if (userOnboardGetData?.wizard_step == 3) {
        naviagte("/manage-nominees");
      }
    }
  }, [userOnboardGetData]);

  console.log("dashboardErrorMessage", dashboardErrorMessage);
  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        isVisible && (
          <div className="container-fluid page_background">
            <AccountDeactivated />
            {/* Nominee Pop-up */}
        {((dashboardErrorMessage?.cheque_status === "FAILED" && ((dashboardErrorMessage?.cheque_message).toLowerCase() !== ("Cheque upload available only for the account failed from bank verification api.").toLowerCase() && (dashboardErrorMessage?.cheque_message).toLowerCase() !== ("Request parameter 'File Name' is required.").toLowerCase())) ||
                        dashboardErrorMessage?.customer_status ===
                          "REG_FAILED" ||
                        dashboardErrorMessage?.fatca_status ===
                          "REG_FAILED") &&     <div className="start_investment_box card-header ac-deactivated-box-bg">
              <div className=" row align-items-between">
                <div className="space-y-1 col-lg-10">
                  <div className="flex items-start">
                    <div className="text-lg font-semibold deactivated-title-new leading-relaxed font-medium">
                      {/* <span className="text-danger">Alert : </span> */}
                      {/* We are currently migrating from our old API to the new
                      version. If you encounter any issues related to valuation,
                      please contact us at sonalit@codeplateau.com,
                      Krishnad@codeplateau.com Thank you for your understanding
                      during this transition. */}
                      {/* <br /> */}
                      
                        <div style={{ marginTop: "5px" }}>
                          <span className="text-danger fw-bold">Alert:</span>
                          <p style={{ marginBottom: 0 }}>
                            Your profile is not completed due to the following
                            reason(s):
                          </p>
                          <ul
                            className="text-danger"
                            style={{ paddingLeft: "20px", marginBottom: 0 }}
                          >
                            {dashboardErrorMessage?.cheque_status ===
                              "FAILED" && (
                              <li>
                                {dashboardErrorMessage?.cheque_message ||
                                  "Cheque verification failed"}
                              </li>
                            )}
                            {dashboardErrorMessage?.customer_status ===
                              "REG_FAILED" && (
                              <li>
                                {dashboardErrorMessage?.customer_message ||
                                  "Customer registration failed"}
                              </li>
                            )}
                            {dashboardErrorMessage?.fatca_status ===
                              "REG_FAILED" && (
                              <li>
                                {dashboardErrorMessage?.fatca_message ||
                                  "FATCA verification failed"}
                              </li>
                            )}
                          </ul>
                          <p style={{ marginTop: "5px" }}>
                            Please resolve the above issue(s) to complete your
                            profile.
                          </p>
                        </div>
                      
                      {/* {dashboardErrorMessage?.customer_status ==
                        "REG_FAILED" && (
                        <div style={{ marginTop: "5px" }}>
                          <spna className="text-danger">Alert : </spna>
                          <p>{dashboardErrorMessage?.customer_message}</p>
                        </div>
                      )}
                      {dashboardErrorMessage?.fatca_status == "REG_FAILED" && (
                        <div style={{ marginTop: "5px" }}>
                          <spna className="text-danger">Alert : </spna>
                          <p>{dashboardErrorMessage?.fatca_message}</p>
                        </div>
                      )} */}
                      {/* In accordance
                      with SEBI guidelines, nomination-related updates have been
                      implemented. Please note that transactions will be
                      restricted until the required nominee details are
                      provided.{" "}
                      <a
                        href="/my-profile"
                        className="text-blue-400 underline hover:text-blue-300 transition"
                      >
                        Click here{" "}
                      </a>
                      to update your nominee information.
                      <br />
                      If you have already submitted your nominee information,
                      please disregard this message.
                      <br />
                      If your IIN is active, you will receive an IIN
                      modification email after updating, which must be accepted
                      to complete the process. */}
                    </div>
                  </div>
                </div>
              </div>
            </div>}

            <DashboardTopHeaderSection />
            <div className="page-inner-content dashboardSectionBox">
              <div className="page_inner_content_box fund_holding_section">
                <div className="d-flex justify-content-between align-itmes-center mb-4">
                  <h5 className="main-heading-title">Holdings</h5>
                  <Link to="/portfolio" className="view_all_btn">
                    View All
                  </Link>
                </div>
                <div>
                  <HoldingSectionSidebar />
                </div>
              </div>
            </div>

            <div class="page-inner-content dashboardSectionBox">
              <div class="page_inner_content_box fund_holding_section position-relative">
                <div class="d-flex justify-content-between align-itmes-center mb-4 ">
                  <h5 className="main-heading-title">Goals</h5>
                  <span>
                    <InvestButton
                      label="Add Goal"
                      url="/goals/add"
                      color="blue"
                      className="me-4"
                      onClick={handleNavigate}
                    />
                    <Link to="#" onClick={handleImageClick}>
                      <img src={UpArrowRound} alt="" />
                    </Link>
                  </span>
                </div>
                {showSwiper && (
                  <Swiper
                    modules={[Navigation, Pagination]}
                    spaceBetween={30}
                    slidesPerView={2}
                    autoplay={{
                      delay: 3000,
                      disableOnInteraction: false,
                    }}
                    breakpoints={{
                      768: {
                        slidesPerView: 2,
                      },
                      0: {
                        slidesPerView: 1,
                      },
                    }}
                    navigation={{
                      prevEl: prevRef?.current,
                      nextEl: nextRef?.current,
                    }}
                    // onBeforeInit={(swiper) => {
                    //   // swiperRef.current = swiper;
                    //   swiper.params.navigation.prevEl = prevRef?.current;
                    //   swiper.params.navigation.nextEl = nextRef?.current;
                    // }}
                    onSwiper={(swiper) => {
                      swiperRef.current = swiper;

                      // Delay to ensure refs are available
                      setTimeout(() => {
                        if (
                          prevRef.current &&
                          nextRef.current &&
                          swiper.params?.navigation
                        ) {
                          swiper.params.navigation.prevEl = prevRef.current;
                          swiper.params.navigation.nextEl = nextRef.current;

                          // Safely re-init only if navigation exists
                          if (swiper.navigation && swiper.navigation.init) {
                            swiper.navigation.destroy();
                            swiper.navigation.init();
                            swiper.navigation.update();
                          }
                        }
                      });
                    }}
                  >
                    {/* {console.log("goalNormalCallgoalNormalCall", goalNormalCall)} */}
                    {goalNormalCall?.length > 0 ? (
                      goalNormalCall?.map((goal, index) => (
                        <div
                          className="col-sm-12 col-md-6 col-lg-6 px-lg-3 mb-4"
                          key={goal?.id}
                        >
                          <SwiperSlide key={index}>
                            <GoalCard
                              goal={goal}
                              setGoalNormalCall={setGoalNormalCall}
                              image={RetirementPlan && BuyHouse}
                            />
                          </SwiperSlide>
                        </div>
                      ))
                    ) : (
                      <div className="no-goals-message">
                        No goals available.
                      </div>
                    )}
                  </Swiper>
                )}

                <div className="custom-navigation">
                  <button ref={prevRef} className="custom-prev-btn">
                    <i className="fas fa-chevron-left"></i>
                  </button>
                  <button ref={nextRef} className="custom-next-btn">
                    <i className="fas fa-chevron-right"></i>
                  </button>
                </div>
              </div>
            </div>

            <div className="page-inner-content">
              <div className="page_inner_content_box disclaimer-box pb-sm-0">
                <div className="row justify-content-center">
                  <div className="col-lg-11 col-sm-11 px-md-4 d-flex flex-sm-row flex-column align-items-center gap-md-5 gap-sm-4 gap-3">
                    <div className="disclaimer_image">
                      <img src={disclaimer_image} alt="Avatar" className="" />
                    </div>
                    <div className="disclaimer-text ms-md-3 mb-sm-4">
                      Mutual funds, like securities investments, are subject to
                      market and other risks, and there can be no assurance that
                      the objectives of any of the schemes of the Fund will be
                      achieved. Please read the Offer Document carefully in its
                      entirety prior to making an investment decision.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      )}
    </>
  );
};

export default Dashboard;
